var map = {
	"./dibujo.jpg": 7195,
	"./flores.jpg": 3225,
	"./fondant.jpg": 3528,
	"./frutales.jpg": 3308,
	"./logo.png": 4427,
	"./mil-hojas.png": 5059,
	"./red-velvet.jpg": 9441,
	"./red-velvet_small.jpg": 744,
	"./tres-chocolates.jpg": 5394,
	"./zanahoria.jpg": 9674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;